import { t } from "../../i18n";
import { Sparkles } from "lucide-react";
import { CopyButton } from "../CopyButton";
import { EmptyResult } from "../EmptyResult";
import { ResultLabel } from "../ResultLabel";
import { GenericValue } from "./GenericValue";

export function GenericResult({ value }: { value: unknown }) {
  if (value === undefined)
    return (
      <EmptyResult icon={<Sparkles size={15} />} text="No result returned" />
    );
  return (
    <div>
      <div className="mb-2 flex items-center justify-between gap-2">
        <ResultLabel>{t("Result")}</ResultLabel>
        <CopyButton value={value} />
      </div>
      <GenericValue value={value} />
    </div>
  );
}
